import React, { ReactNode } from 'react'
import CompleteScreening from '../components/CompleteScreening'
import DoYouQualify from '../components/DoYouQualify'
import SelectSource from '../components/SelectSource'
import ShareYourDeets from '../components/ShareYourDeets'

export interface IApplicationStep {
  label: EApplicationStepsLabel
  content: ReactNode
}

export enum EApplicationStepsLabel {
  DO_YOU_QUALIFY = 'Do you qualify?',
  SHARE_YOUR_DEETS = 'Share your deets',
  COMPLETE_SCREENING = 'Complete screening',
  COMPLETED = 'Completed'
}

export function getApplicationSteps(): IApplicationStep[] {
  return [
    { label: EApplicationStepsLabel.DO_YOU_QUALIFY, content: <DoYouQualify /> },
    { label: EApplicationStepsLabel.SHARE_YOUR_DEETS, content: <ShareYourDeets /> },
    { label: EApplicationStepsLabel.COMPLETE_SCREENING, content: <CompleteScreening /> },
    { label: EApplicationStepsLabel.COMPLETED, content: <SelectSource /> }
  ]
}
